import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import '../Css/componentes/navbar.css';
import logo from '../Images/logo_investi2.png'; // Importa tu logo

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      {/* Logo y nombre de la empresa */}
      <div className="logo-container">
        <img src={logo} alt="Logo de la empresa" className="logo-img" />
        <span className="logo-text">Investí</span>
      </div>

      {/* Botón de menú hamburguesa */}
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? '✕' : '☰'}
      </button>

      {/* Lista de enlaces */}
      <ul className={`links_navegador ${isMenuOpen ? 'active' : ''}`}>
        <li>
          <NavLink 
            to="/" 
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={toggleMenu}
          >
            Inicio
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/about" 
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={toggleMenu}
          >
            Sobre Nosotros
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/servicios" 
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={toggleMenu}
          >
            Servicios
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/contact" 
            className={({ isActive }) => (isActive ? 'active' : '')}
            onClick={toggleMenu}
          >
            Contacto
          </NavLink>
        </li>
        <li>
          <NavLink
            to= "/testimonios"
            className ={({isActive}) => (isActive ? 'active' : '')}
            onClick={toggleMenu}
            >
            Testimonios
          </NavLink>
        </li>
      
      </ul>
    </nav>
  );
};

export default Navbar;